var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main__div" },
    [
      _c(
        "el-container",
        { staticClass: "el-container__main" },
        [
          _vm.hasNewLeftNavPermission
            ? _c("new-main-left-menu")
            : _c("main-left-menu"),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm._t("default", function () {
                    return [_c("h1", [_vm._v("Router View should be here! ")])]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("main-footer", { attrs: { hidden: _vm.hasNewLeftNavPermission } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }